import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['badge', 'count', 'tooltip']
  static values = {
    section: String,
    count: Number,
  }

  declare readonly badgeTarget: HTMLElement
  declare readonly hasBadgeTarget: boolean
  declare readonly countTarget: HTMLElement
  declare readonly hasCountTarget: boolean
  declare readonly tooltipTarget: HTMLElement
  declare readonly hasTooltipTarget: boolean
  declare sectionValue: string
  declare countValue: number

  private boundHandleMismatchFinalized: EventListener | null = null

  connect(): void {
    this.boundHandleMismatchFinalized = this.handleMismatchFinalized.bind(
      this
    ) as EventListener
    document.addEventListener(
      'mismatch:finalized',
      this.boundHandleMismatchFinalized
    )
  }

  disconnect(): void {
    if (this.boundHandleMismatchFinalized) {
      document.removeEventListener(
        'mismatch:finalized',
        this.boundHandleMismatchFinalized
      )
      this.boundHandleMismatchFinalized = null
    }
  }

  private handleMismatchFinalized(
    event: CustomEvent<{ id: number; section?: string }>
  ): void {
    const { section } = event.detail

    if (section !== this.sectionValue) {
      return
    }

    this.countValue = Math.max(0, this.countValue - 1)

    if (this.countValue === 0) {
      this.removeBadge()
    } else {
      this.updateBadgeCount()
    }
  }

  private updateBadgeCount(): void {
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.countValue.toString()
    }
    if (this.hasTooltipTarget) {
      // @ts-expect-error - I18n is available globally
      const tooltipText = I18n.t(
        'company_consolidations.account_links.mismatches_count',
        { count: this.countValue }
      )
      this.tooltipTarget.setAttribute('title', tooltipText)
      this.tooltipTarget.setAttribute('data-original-title', tooltipText)
    }
  }

  private removeBadge(): void {
    if (this.hasBadgeTarget) {
      this.badgeTarget.remove()
    }
  }
}
